/**
 * Get uuid or shorten id(without prefix) of QTI Response
 **/
export function getResponseId(id: string) {
  const uuidMatch =
    /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i.exec(id);
  if (uuidMatch && uuidMatch.length > 1) {
    return uuidMatch[1] ?? id;
  }
  const responseMatch = /resp(?:onse)?_(.*)$/i.exec(id);
  if (responseMatch && responseMatch.length > 1) {
    return responseMatch[1] ?? id;
  }
  return id;
}
